module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-13-f8808dfe984fc186003a9fdfde9b7848.jpg";